import { useCallback, useEffect, useState } from "react";

/**
 * Loads data with loading/error state and a reload function. A refetch (a live update, a reload)
 * keeps the last data on screen: a failed refresh does not replace it with an error.
 */
export function useAsync<T>(fn: () => Promise<T>, deps: unknown[]) {
  const [state, setState] = useState<{ data: T | null; error: Error | null; loading: boolean }>({ data: null, error: null, loading: true });
  const run = useCallback(() => {
    let live = true;
    setState((s) => ({ ...s, loading: true }));
    fn().then((data) => live && setState({ data, error: null, loading: false }), (error) => live && setState((s) => (s.data != null ? { ...s, loading: false } : { data: null, error, loading: false })));
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  useEffect(run, [run]);
  return { ...state, reload: run };
}
